module.exports = __webpack_public_path__ + "img/pc_contact.d7acd6ab.png";